export default {
      id: "grid-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "local/templates/prioritet/images/symbols/symbols.svg#grid",
      toString: function () {
        return this.url;
      }
    }